/**
 *
 * Results
 *
 */

import React from "react";
import PropTypes from "prop-types";

import {
  deepClone,
  getPercentile,
  getAverage,
  constantData,
  setConstantData,
  setResultsData,
  getSelectOptions,
  sortWithLookupArray,
} from "helpers";

import { percentileExplanation } from "data/data";

import BarChart from "components/BarChart";
import Checkbox from "components/Checkbox";

import ResultsWrapper from "./styles/ResultsWrapper";
import ResultsVerticalWrapper from "./styles/ResultsVerticalWrapper";
import ResultsHorizontalWrapper from "./styles/ResultsHorizontalWrapper";
import ResultsAverageHeader from "./styles/ResultsAverageHeader";
import ResultsAveragePrice from "./styles/ResultsAveragePrice";
import ResultsGoBack from "./styles/ResultsGoBack";
import ResultsNoDataText from "./styles/ResultsNoDataText";
import ResultsNoDataBox from "./styles/ResultsNoDataBox";
import ResultsPercentileBar from "./styles/ResultsPercentileBar";
import ResultsHorizontalLine from "./styles/ResultsHorizontalLine";
import ResultsResponsesNumber from "./styles/ResultsResponsesNumber";
import ResultsPercentileWrapper from "./styles/ResultsPercentileWrapper";
import ResultsInfoIcon from "./styles/ResultsInfoIcon";
import ResultsInfoText from "./styles/ResultsInfoText";
import ResultsUserResponse from "./styles/ResultsUserResponse";
import ResultsUserResponseWrapper from "./styles/ResultsUserResponseWrapper";

// import Select from "components/Select";
// import SalaryForm from "./containers/SalaryForm";
// import SalaryForm from "containers/SalaryForm";

import SalaryForm2 from "containers/SalaryForm2";

// import { readRemoteFile } from "react-papaparse";
// import DataCSV from "data/data.csv";
import { salaryRanges, columnHeaders } from "data/data";
import App from "App";

class Results extends React.PureComponent {
  constructor() {
    super();

    this.handleFilter = this.handleFilter.bind(this);
    this.handleShowCheckbox = this.handleShowCheckbox.bind(this);
    this.handleShowResponse = this.handleShowResponse.bind(this);

    this.displayResults = this.displayResults.bind(this);
    this.displayForm = this.displayForm.bind(this);
    this.updateResultsData = this.updateResultsData.bind(this);
    this.updateFiltersArray = this.updateFiltersArray.bind(this);
    this.updateBarChartData = this.updateBarChartData.bind(this);
    
    // this.filtersArray = ["country"];

    this.state = {
      filters: {},
      chartData: {},
      showInfo: false,

      // formData: {
      //   region: "",
      //   country: "",
      //   city: "",
      //   state: "",
      //   education: "",
      //   industry: "",
      //   position: "",
      //   experience: "",
      //   gender: "",
      //   salary: "",
      //   userResponseIndex: "",
      // },
      // filtersArray: [],
      // countryResponses: [],
      // selectedCountryIndexes: [],
      // selectedStateIndexes: [],

      // filtersArray: ["country"],

      // isResultsDisplayed: false,
      // filtersArray: ["country"],
      // resultsData: {},
      // formData: [],
    };
  }

  updateBarChartData(data, props) {
    const filtersArray = data.filtersArray;
    const formData = data.formData;

    const resultsDataValue = setResultsData({ props, filtersArray, formData });

    this.props.updateForm();
    // this.props.updateResultsData(
    this.props.updateResultsData(
      resultsDataValue.histogramData,
      // [100, 200, 300, 0, 0, 0, 0, 0, 0],
      this.state.resultsData.labels,
      this.state.resultsData.userResponseIndex,
      this.state.resultsData.formData,
      this.state.resultsData.filteredResponses,
      filtersArray
    );

    this.setState({
      resultsData: {
        ...this.state.resultsData,
        // chartData: [100, 200, 300],
      },
    });

  }

  displayResults() {
    this.setState({
      isResultsDisplayed: true,
    });
  }

  displayForm() {
    this.setState({
      isResultsDisplayed: false,
    });
  }

  updateFiltersArray(newArray) {
    this.setState({
      filtersArray: newArray,
    });
  }

  updateResultsData(
    chartData,
    labels,
    userResponseIndex,
    formData,
    filteredResponses
  ) {
    this.setState({
      resultsData: {
        chartData: chartData,
        labels: labels,
        userResponseIndex: userResponseIndex,
        formData: formData,
        filteredResponses: filteredResponses,
      },
    });

  }

  updateFormData = (newFormData) => {
    this.setState({ formData: newFormData });
  };

  updateChartData = (newChartData) => {
    this.setState((prevState) => ({
      resultsData: {
        ...prevState.resultsData,
        chartData: newChartData,
      },
    }));
  };

  updateLabels = (newLabels) => {
    this.setState((prevState) => ({
      resultsData: {
        ...prevState.resultsData,
        labels: newLabels,
      },
    }));
  };

  updateUserResponseIndex = (newIndex) => {
    this.setState((prevState) => ({
      resultsData: {
        ...prevState.resultsData,
        userResponseIndex: newIndex,
      },
    }));
  };

  componentDidMount() {
    this.handleFilter({
      target: {
        value: "country",
      },
    });
  }

  handleFilter(event) {
    const value = event.target.value;
    const updateFilters = () => {
      const filtersArray = [];
      for (const property in this.state.filters) {
        if (this.state.filters[property]) {
          filtersArray.push(property);
        }
      }
      this.props.updateFiltersArray(filtersArray);
    };

    const newFilters = deepClone(this.state.filters);
    
    if (value === "country") {
      this.setState((prevState) => {
        if (newFilters.state && prevState.filters.country) {
          newFilters.state = false;
        }
        if (newFilters.city && prevState.filters.country) {
          newFilters.city = false;
        }
        newFilters.country = !prevState.filters.country;
        return {
          filters: newFilters,
        };
      }, updateFilters);
    } else if (value === "state") {
      this.setState((prevState) => {
        if (!newFilters.country && !prevState.filters.state) {
          newFilters.country = true;
        }
        if (newFilters.city && prevState.filters.state) {
          newFilters.city = false;
        }
        newFilters.state = !prevState.filters.state;
        return {
          filters: newFilters,
        };
      }, updateFilters);
    } else if (value === "city") {
      this.setState((prevState) => {
        if (!newFilters.country && !prevState.filters.city) {
          newFilters.country = true;
        }
        if (!newFilters.state && !prevState.filters.city) {
          newFilters.state = true;
        }
        newFilters.city = !prevState.filters.city;
        return {
          filters: newFilters,
        };
      }, updateFilters);
    } else {
      this.setState((prevState) => {
        newFilters[value] = !prevState.filters[value];
        return {
          filters: newFilters,
        };
      }, updateFilters);
    }
  }

  handleShowCheckbox(filter) {
    const { resultsData } = this.props;
    const { formData } = resultsData;
    if (formData && formData[filter]) {
      return (
        <Checkbox
          label={filter.charAt(0).toUpperCase() + filter.slice(1)}
          value={filter}
          checked={this.state.filters[filter]}
          sendDataCallback={this.handleFilter}
        />
      );
    }
  }
  handleShowResponse(whichResponse) {
    
    const formData = this.props.resultsData.formData;
    const label =
      whichResponse.charAt(0).toUpperCase() + whichResponse.slice(1);
    if (formData && formData[whichResponse]) {
      return (
        <ResultsUserResponse
          hasLineThrough={!this.state.filters[whichResponse]}
        >
          {`${label}:`}
          <span>{`${formData[whichResponse]}`}</span>
        </ResultsUserResponse>
      );
    }
  }

  render() {
    let { resultsData, displayForm } = this.props;

    let { chartData, labels, userResponseIndex, filteredResponses } =
      resultsData;

    // chartData = [
    //   100,
    //   200,
    //   300,
    //   // generate randon number between 100 and 300
    //   Math.floor(Math.random() * (300 - 100 + 1)) + 100,
    //   Math.floor(Math.random() * (300 - 100 + 1)) + 100,
    //   Math.floor(Math.random() * (300 - 100 + 1)) + 100,
    // ];

    const { showInfo } = this.state;

    const { isResultsDisplayed, filtersArray } = this.state;

    const accessToken = localStorage.getItem("access_token");

    // if (accessToken) {
    if (true) {
      return (
        <ResultsWrapper>
          <div className="sf-section__title">
            <h3 className="h3-d tr-form__title">
              <span>The results</span>
              <br />
              <span className="stl-1">are in...</span>
            </h3>
            {/* <div className="sf-section__title__shape">
            <img src="images/salary/sf-section__title__shape.svg" alt="" />
          </div> */}

            <h3
              style={{
                marginTop: "24px",
              }}
            >
              {"Filter by:"}
            </h3>
            <ResultsHorizontalWrapper>
              {this.handleShowCheckbox("country")}
              {this.handleShowCheckbox("state")}
              {this.handleShowCheckbox("city")}
              {this.handleShowCheckbox("industry")}
              {this.handleShowCheckbox("position")}
              {this.handleShowCheckbox("education")}
              {this.handleShowCheckbox("experience")}
              {this.handleShowCheckbox("gender")}
            </ResultsHorizontalWrapper>
            <ResultsUserResponseWrapper>
              {this.handleShowResponse("country")}
              {this.handleShowResponse("state")}
              {this.handleShowResponse("city")}
              {this.handleShowResponse("industry")}
              {this.handleShowResponse("position")}
              {this.handleShowResponse("education")}
              {this.handleShowResponse("experience")}
              {this.handleShowResponse("gender")}
            </ResultsUserResponseWrapper>

            {/* new form - start */}
            {/* <Select
            options={countryResponses && countryResponses.sort()}
            sendDataCallback={this.selectCountry}
            label={"Select your country"}
            isRequired={true}
            showError={countryFormAlert}
          /> */}

            {/* <SalaryForm
            isResultsDisplayed={false}
            columnHeaders={columnHeaders}
            salaryRanges={salaryRanges}
            displayResults={false}
            updateResultsData={false}
            filtersArray={this.state.filtersArray.length}
          /> */}
            {/* new form - end */}

            <ResultsGoBack
              onClick={displayForm}
              className="default-button tr-form__submit default-button--bordered-dark"
            >
              <span className="material-symbols-outlined">restart_alt</span>
              Reset to default
            </ResultsGoBack>

            <SalaryForm2
              isResultsDisplayed={false}
              columnHeaders={columnHeaders}
              salaryRanges={salaryRanges}
              displayResults={this.displayResults}
              updateResultsData={this.updateResultsData}
              filtersArray={filtersArray}
              updateFormData={this.updateFormData}
              updateChartData={this.updateChartData}
              updateLabels={this.updateLabels}
              updateUserResponseIndex={this.updateUserResponseIndex}
              updateBarChartData={this.updateBarChartData}
            ></SalaryForm2>
          </div>

          <div
            className="sf-section__main"
            style={{
              width: "750px",
            }}
          >
            <ResultsVerticalWrapper
              thisStylesSmall={{
                position: "relative",
                top: "-6rem",
                right: 0,
                width: "50%",
                marginBottom: "2rem",
              }}
              thisStylesLarge={{
                top: "-4.5rem",
              }}
            >
              <ResultsHorizontalWrapper>
                <ResultsAverageHeader>
                  {filteredResponses.length ? "Average salary (USD) is:" : ""}
                </ResultsAverageHeader>
              </ResultsHorizontalWrapper>
              <ResultsHorizontalWrapper>
                <ResultsAveragePrice>
                  {filteredResponses.length ? (
                    <>
                      {`$${
                        Math.round(
                          (getAverage(filteredResponses) / 1000) * 10
                        ) / 10
                      }K`}
                      <span>{"per year"}</span>
                    </>
                  ) : (
                    ""
                  )}
                </ResultsAveragePrice>
              </ResultsHorizontalWrapper>
            </ResultsVerticalWrapper>
            {filteredResponses.length === 0 ? (
              <ResultsNoDataBox>
                <ResultsNoDataText>
                  {"Data not available...😔"}
                </ResultsNoDataText>
              </ResultsNoDataBox>
            ) : (
              <BarChart
                chartData={chartData}
                labels={labels}
                userResponseIndex={userResponseIndex}
              />
              // <></>
            )}
            <ResultsHorizontalWrapper
              thisStyles={{
                width: "100%",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              {/* <ResultsResponsesNumber responses={filteredResponses.length}>
              {"Number of responses:"}
              <span>{filteredResponses.length}</span>
            </ResultsResponsesNumber> */}
              {chartData[userResponseIndex] ? (
                <span> Your current annual salary (USD)</span>
              ) : (
                ""
              )}
            </ResultsHorizontalWrapper>
            <ResultsHorizontalLine />
            {filteredResponses.length > 2 ? (
              <ResultsVerticalWrapper
                thisStyles={{
                  width: "100%",
                  position: "absolute",
                }}
              >
                <ResultsHorizontalWrapper
                  thisStyles={{
                    justifyContent: "flex-start",
                    width: "90%",
                    minWidth: "30rem",
                    maxWidth: "80rem",
                  }}
                >
                  {/* <ResultsInfoIcon
                  onMouseOver={() => {
                    this.setState({
                      showInfo: true,
                    });
                  }}
                  onMouseOut={() => {
                    this.setState({
                      showInfo: false,
                    });
                  }}
                >
                  {"?"}
                </ResultsInfoIcon>
                {showInfo ? (
                  <ResultsInfoText>{percentileExplanation}</ResultsInfoText>
                ) : (
                  ""
                )} */}
                </ResultsHorizontalWrapper>
                <ResultsPercentileWrapper>
                  <ResultsPercentileBar index={1}>
                    {"25"}
                    {!showInfo ? <sup>th</sup> : ""}

                    {"percentile:"}
                  </ResultsPercentileBar>
                  <span>
                    $
                    {Math.round(
                      (getPercentile(25, filteredResponses) / 1000) * 10
                    ) / 10}
                    K
                  </span>
                </ResultsPercentileWrapper>

                <ResultsPercentileWrapper>
                  <ResultsPercentileBar index={2}>
                    {"50"}
                    {!showInfo ? <sup>th</sup> : ""}
                    {"percentile / Median:"}
                  </ResultsPercentileBar>
                  <span>
                    $
                    {Math.round(
                      (getPercentile(50, filteredResponses) / 1000) * 10
                    ) / 10}
                    K
                  </span>
                </ResultsPercentileWrapper>
                <ResultsPercentileWrapper>
                  <ResultsPercentileBar index={3}>
                    {"75"}
                    {!showInfo ? <sup>th</sup> : ""}
                    {"percentile:"}
                  </ResultsPercentileBar>
                  <span>
                    $
                    {Math.round(
                      (getPercentile(75, filteredResponses) / 1000) * 10
                    ) / 10}
                    K
                  </span>
                </ResultsPercentileWrapper>

                <p
                  style={{
                    marginTop: "16px",
                    fontSize: "14px",
                    // fontWeight: "300",
                    lineHeight: "22px",
                    color: "#6C6C6C",
                  }}
                >
                  The percentiles here indicate the annual salary below which a
                  given percentage (25%, 50% or 75%) of observations in the
                  observation group falls; i.e., 75th percentile = $100K means
                  that 75% of people earn $100K or less annually (only 25% of
                  people earn more). The 50th percentile is the central value,
                  also known as the median.
                </p>

                <ResultsHorizontalLine />
              </ResultsVerticalWrapper>
            ) : (
              ""
            )}
            {/* <h3>{"Filter results by your:"}</h3>
          <ResultsHorizontalWrapper>
            {this.handleShowCheckbox("country")}
            {this.handleShowCheckbox("state")}
            {this.handleShowCheckbox("city")}
            {this.handleShowCheckbox("industry")}
            {this.handleShowCheckbox("position")}
            {this.handleShowCheckbox("education")}
            {this.handleShowCheckbox("experience")}
            {this.handleShowCheckbox("gender")}
          </ResultsHorizontalWrapper>
          <ResultsUserResponseWrapper>
            {this.handleShowResponse("country")}
            {this.handleShowResponse("state")}
            {this.handleShowResponse("city")}
            {this.handleShowResponse("industry")}
            {this.handleShowResponse("position")}
            {this.handleShowResponse("education")}
            {this.handleShowResponse("experience")}
            {this.handleShowResponse("gender")}
          </ResultsUserResponseWrapper> */}
          </div>
        </ResultsWrapper>
      );

      console.log("Access Token:", accessToken);
    } else {
      console.log("Token Not available");
    }
  }
}

Results.propTypes = {
  chartData: PropTypes.array,
  labels: PropTypes.array,
};

export default Results;
